// Paste your Calendly scheduling link here. It is used by every
// "Claim Your Free 1:1 Consultation" and "Book Free Consultation" button.
export const CALENDLY_URL = 'https://calendly.com/salescott84/30min';
